import styled from 'styled-components';

export default styled.div`
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    max-height: 100vh;
    font-size: 1.1em;
    font-weight: 400;
    z-index: 3000;
    padding: 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.95);
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/FullOverlay.tsx